import { useMemo } from 'react';

import { useFishGroupsController_getOverview } from '@/services/hooks';
import type { ClientFishGroupsOverviewDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapClientFishGroupsOverviewToDomain } from './mappers';
import type { UseGetClientFishGroupsOverviewResult } from './types';

export const useGetClientFishGroupsOverview = (
    clientId: number,
    options?: DomainQueryOptions<ClientFishGroupsOverviewDto>
): UseGetClientFishGroupsOverviewResult => {
    const query = useFishGroupsController_getOverview(clientId, options);

    const overview = useMemo(() => {
        if (!query.data?.data) return null;
        return mapClientFishGroupsOverviewToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: overview,
        isLoading: query.isPending,
        isFetched: query.isFetched,
        isFetching: query.isFetching,
        error: query.error,
        refetch: query.refetch,
    };
};
